import React from 'react';
import { connect } from 'react-redux';
import ListItem from 'components/ListItem';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import {
    ProductId,
    ProductWitholdingPeriodDays
} from 'services/products/types';
import { makeSelectProductFieldValue } from 'services/products/selectors';
import { numberOfDays } from 'utils/formatter/number-of-days';

export interface OwnProps {
    productId: ProductId;
}

export interface ConnectedProps {
    withholdingPeriodDays: ProductWitholdingPeriodDays;
}

type Props = OwnProps & ConnectedProps;

export class SummaryProductWithholdingPeriodListItemComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { withholdingPeriodDays } = this.props;

        return (
            <ListItem
                description="Withholding period"
                value={numberOfDays(withholdingPeriodDays)}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    withholdingPeriodDays: makeSelectProductFieldValue('witholdingPeriodDays')
});

export default connect(mapStateToProps)(
    SummaryProductWithholdingPeriodListItemComponent
);
